// SPDX-License-Identifier: AGPL-3.0-or-later

import styles from '@app/features/app/components/dialogs/shared/SettingsSection.module.css';
import {Accordion} from '@app/features/ui/accordion/Accordion';
import {isSectionIdValid} from '@app/features/user/components/settings_utils/SettingsSectionRegistry';
import {clsx} from 'clsx';
import type React from 'react';
import {useEffect} from 'react';
export interface SettingsSectionProps {
	id: string;
	title: React.ReactNode;
	description?: React.ReactNode;
	isAdvanced?: boolean;
	defaultExpanded?: boolean;
	children: React.ReactNode;
	className?: string;
}
export const SettingsSection: React.FC<SettingsSectionProps> = ({
	id,
	title,
	description,
	isAdvanced = false,
	defaultExpanded = true,
	children,
	className,
}) => {
	useEffect(() => {
		if (import.meta.env.DEV && !isSectionIdValid(id)) {
			console.warn(
				`[SettingsSection] Unknown section ID "${id}" - ensure it's registered in SettingsSectionRegistry.tsx`,
			);
		}
	}, [id]);
	if (isAdvanced) {
		return (
			<Accordion
				id={id}
				title={title}
				description={description}
				defaultExpanded={defaultExpanded}
				className={className}
			>
				{children}
			</Accordion>
		);
	}
	return (
		<section id={id} className={clsx(styles.section, className)}>
			<div className={styles.sectionHeader}>
				<h3 className={styles.sectionTitle}>{title}</h3>
				{description ? <p className={styles.sectionDescription}>{description}</p> : null}
			</div>
			<div className={styles.sectionContent}>{children}</div>
		</section>
	);
};
